var _path, _g, _g2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgKr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.31)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75M-75 778.3H75m-150 37.5H75m-150 37.5H75"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808M689.187 230.644l-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KR.c9ba23c1a4c1c82743ca7bb455abab24.svg";